import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  instructionsPayAuth: {
    defaultMessage: 'To continue, follow the instructions at {providerName} ',
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.instructionsPayAuth',
  },
  providerInfo: {
    defaultMessage: "Can't see the {providerName} login window?",
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.providerInfo',
  },
});
